import type { IntegratedModuleId } from "@/core/config";
import { getModuleBaseUrl } from "@/core/config";
import { routes } from "@/router/all_routes";

export interface ModuleIntegrationRow {
  id: IntegratedModuleId;
  label: string;
  baseUrl: string;
  sampleEmbedPath: string;
  hospitolRoute: string;
  adminConsoleRoute?: string;
  notes?: string;
}

export const MODULE_INTEGRATIONS: ModuleIntegrationRow[] = [
  {
    id: "inventory",
    label: "Stock (ISC)",
    baseUrl: getModuleBaseUrl("inventory"),
    sampleEmbedPath: "/tenant/inventory/articles?embed=1",
    hospitolRoute: routes.supplyMedicinesLevels,
    adminConsoleRoute: routes.supplyAdminConsole,
    notes: "Parcours natif : articles, niveaux, réceptions · iframe = admin ISC",
  },
  {
    id: "rh",
    label: "Ressources humaines",
    baseUrl: getModuleBaseUrl("rh"),
    sampleEmbedPath: "/tenant/employees?embed=1",
    hospitolRoute: routes.rhEmployees,
    adminConsoleRoute: routes.rhAdminConsole,
    notes: "Personnel, services, plannings natifs · iframe = console RH",
  },
  {
    id: "billing",
    label: "Facturation Kanakku",
    baseUrl: getModuleBaseUrl("billing"),
    sampleEmbedPath: "/tenant/billing/invoices?embed=1",
    hospitolRoute: routes.billingInvoices,
    adminConsoleRoute: routes.billingAdminConsole,
    notes: "Recettes consolidées natives · iframe = Kanakku complet",
  },
];

export async function probeModuleOrigin(
  moduleId: IntegratedModuleId,
): Promise<{ reachable: boolean; detail: string }> {
  const baseUrl = getModuleBaseUrl(moduleId);
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    await fetch(baseUrl, { method: "GET", mode: "no-cors", signal: controller.signal });
    clearTimeout(timeout);
    return { reachable: true, detail: `${baseUrl} — réponse reçue` };
  } catch (err) {
    const message = err instanceof Error ? err.message : "Erreur réseau";
    return {
      reachable: false,
      detail: `${baseUrl} — ${message}`,
    };
  }
}
